import { Text } from '@bigcommerce/big-design';

export function AddonsColumn(product) {
	if (!product.option_values) return 'N/A';

	return Object.entries(product.option_values).map(([option, value]) => (
		<Text key={option} marginBottom="none">
			{option} ({value})
		</Text>
	));
}
